import React from 'react';
import './Footer.css';
import { ReactComponent as GithubIcon } from '../../images/github.svg'
import { ReactComponent as EmailIcon } from '../../images/email.svg'

function Footer() {
    return (
        <footer>
            <ul>
                <li><a href="mailto:tim-t@hotmail.de" aria-label='Get in contact with me'>
                    <EmailIcon />
                </a></li>
                <li><a href="https://github.com/timii" target="_blank" rel="noreferrer" aria-label='Go to my GitHub'>
                    <GithubIcon fill='white' />
                </a></li>
            </ul>
        </footer>
    );
}

export default Footer;